/**
 * External dependencies
 */
import React from "react";
import { Box } from "@towersystems/towersystems-design-system";
import classnames from "classnames";
import { connect } from "react-redux";

/**
 * Internal dependencies
 */
import ReportFactory from "lib/report-factory";
import { getBuilderReportId } from "state/ui/report-builder/selectors";
import { getEditedReport } from "state/reports/selectors";

/**
 * Style dependencies
 */
import "./styles.scss";

const ReportPreview = ({ report, reportId }) => {
  if (!report) {
    return null;
  }

  const classes = classnames("report-builder__report-preview");

  const component = ReportFactory.create({
    reportId,
    template: report.template,
    renderHeader: () => null,
    includeEdits: true,
    draggable: false,
    showActions: false,
  });

  return (
    <Box className={classes}>
      <Box className="report-builder__report-preview-inner">{component}</Box>
    </Box>
  );
};
export default connect((state) => {
  let reportId = getBuilderReportId(state);
  return {
    reportId,
    report: getEditedReport(state, reportId),
  };
})(ReportPreview);
